class SliderMedia extends HTMLElement {
    constructor() {
        super();

        this.init();


    }

    init() {
        const swiper = new Swiper(this.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',
            loop: true,

            // If we need pagination
            pagination: {
                el: this.querySelector('.swiper-pagination'),
            },

            // Navigation arrows
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },

            // And if we need scrollbar
            scrollbar: {
                el: this.querySelector('.swiper-scrollbar'),
            },
        });
    }
}

customElements.define('slider-media', SliderMedia);